var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Centered',{staticClass:"user-view"},[_c('Navigation'),(_vm.authorizedUser.backoffice)?_c('BackofficeOverview',{staticClass:"padding-left"}):_c('Unauthorized')],1)}
var staticRenderFns = []

export { render, staticRenderFns }